/* ==========================================================================
   Scent Event Offers  (sections/scent-event-offers.liquid)
   --------------------------------------------------------------------------
   - Sorts offer cards into Live / Coming Soon / What You Missed by date
   - Builds Flickity sliders only when the cards don't all fit
   - Updates countdowns every 60s without resetting the sliders
   - Lazy-loads the banner video for the current screen size
   - Rebuilds on breakpoint changes and on theme-editor edits

   Needs Flickity (assets/flickity.pkgd.min.js).
   Works with any number of [data-scent-event] sections on a page.
   ========================================================================== */
(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 768px)');
  var TABLET_MQ = window.matchMedia('(max-width: 990px)');

  var ARROW_THRESHOLD = 3;          // arrows only when a bucket has MORE cards than this
  var REFRESH_MS = 60 * 1000;       // re-check offer dates every minute

  var forEach = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  /* ---------- Helpers ---------------------------------------------------- */

  function whenFlickity(cb, tries) {
    tries = tries || 0;
    if (typeof window.Flickity !== 'undefined') return cb();
    if (tries > 60) return;           // give up after ~3s
    setTimeout(function () { whenFlickity(cb, tries + 1); }, 50);
  }

  function seFormatTimeLeft(msLeft, thresholdHours) {
  const hours = msLeft / 3600000;
  if (hours <= 0) return '';
  if (hours < thresholdHours) {
    const h = Math.max(1, Math.ceil(hours));
    return h + (h === 1 ? ' Hour Left' : ' Hours Left');
  }
  const d = Math.ceil(hours / 24);
  return d + (d === 1 ? ' Day Left' : ' Days Left');
}

  // Reads a date from data-starts / data-ends (epoch from Liquid),
  // falling back to parsing the raw "YYYY-MM-DD HH:MM" text.
  function toEpoch(node, key) {
    var n = parseInt(node.getAttribute('data-' + key), 10);
    if (!isNaN(n) && n > 0) return n;
    var raw = node.getAttribute('data-' + key + '-raw');
    if (raw) {
      var t = Date.parse(raw.replace(' ', 'T'));
      if (!isNaN(t)) return Math.floor(t / 1000);
    }
    return NaN;
  }

  function fmtDate(u) {
    var d = new Date(u * 1000);
    return (d.getMonth() + 1) + ' / ' + String(d.getDate()).padStart(2, '0') + ' / ' + d.getFullYear();
  }
  // "Oct 30"
function fmtShortDate(u) {
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var d = new Date(u * 1000);
  return months[d.getMonth()] + ' ' + d.getDate();
}

  function fmtTimeLeft(s) {
    var h = Math.floor(s / 3600);
    if (h >= 72) return Math.ceil(h / 24) + ' Days Left';
    if (h >= 1) return h + ' Hours Left';
    return Math.max(1, Math.ceil(s / 60)) + ' Min Left';
  }

  // Live -> live image. Coming / Missed -> "Coming Soon / Ended" image if uploaded.
  function pickImage(card, where) {
    var live = card.querySelector('.se-card__img--live');
    var blur = card.querySelector('.se-card__img--blur');
    if (where === 'live') {
      if (blur && live) blur.remove();     // no live image? keep the other as a fallback
    } else if (blur && live) {
      live.remove();
    }
  }

  /* ---------- Slider options -------------------------------------------- */

  // Same options for every bucket: one card per move, no dots,
  // centred on mobile (neighbours peek), left-aligned on desktop.
  function sliderOpts(count) {
    var mobile = MOBILE_MQ.matches;
    return {
      cellAlign: mobile ? 'center' : 'left',
      contain: true,
      groupCells: false,
      pageDots: false,
      prevNextButtons: !mobile && count > ARROW_THRESHOLD,
      wrapAround: false,
      imagesLoaded: true
    };
  }

  // Live: stacked on mobile when 3 or fewer; tablet fits 2, desktop fits 3.
  function liveShouldSlide(count) {
    if (MOBILE_MQ.matches) return count > ARROW_THRESHOLD;
    return count > (TABLET_MQ.matches ? 2 : 3);
  }

  // Coming / Missed: always slide on mobile; tablet fits 2, desktop fits 4.
  function carouselShouldSlide(count) {
    if (MOBILE_MQ.matches) return true;
    return count > (TABLET_MQ.matches ? 2 : 4);
  }

  /* ---------- Flickity fixes -------------------------------------------- */

  // With contain:true Flickity keeps "dead" stops at the end that don't move.
  // This finds the last stop that actually changes position.
  function lastReachable(flkty) {
    var s = flkty.slides, last = s.length - 1;
    if (last < 1) return Math.max(last, 0);
    var end = s[last].target;
    while (last > 0 && Math.abs(s[last - 1].target - end) < 1) last--;
    return last;
  }

  // Never rest on a dead stop, and disable "next" at the real end.
  function fixContain(flkty) {
    function clamp() {
      var max = lastReachable(flkty);
      if (flkty.selectedIndex > max) { flkty.select(max, false, true); return; }
      if (flkty.nextButton && flkty.selectedIndex >= max) flkty.nextButton.disable();
    }
    flkty.on('select', clamp);
    flkty.on('resize', clamp);
    clamp();
  }

  /* ---------- Progress bar ---------------------------------------------- */

  // Starts at the share of the row already in view, reaches 100% at the end.
  // Hidden when there is no slider or everything fits.
  function bindProgress(container) {
    var block = container.closest('.se-block');
    var bar = block && block.querySelector('[data-progress]');
    if (!bar) return;
    var fill = bar.querySelector('span');
    var flkty = container.flkty;
    if (!flkty) { bar.hidden = true; return; }

    var progress = 0;
    function update(p) {
      if (typeof p === 'number') progress = Math.max(0, Math.min(1, p));
      var canScroll = lastReachable(flkty) > 0;
      bar.hidden = !canScroll;
      if (!canScroll) return;
      var start = Math.min(100, flkty.size.width / flkty.slideableWidth * 100);
      fill.style.width = (start + (100 - start) * progress) + '%';
    }

    flkty.on('scroll', update);
    flkty.on('resize', function () { update(); });
    update(0);
  }

  /* ---------- Buckets ---------------------------------------------------- */

  function destroySlider(container) {
    var existing = container.flkty || (window.Flickity && Flickity.data && Flickity.data(container));
    if (existing) { try { existing.destroy(); } catch (e) {} }
    container.flkty = null;
  }

  // Rebuilds a bucket only when its cards or slider options change (or when forced).
  function syncSlider(container, cards, force, opts, enable) {
    var sig = cards.map(function (c) { return c.getAttribute('data-key'); }).join('|') +
              '#' + (enable ? JSON.stringify(opts) : 'off');
    var existing = container.flkty || (Flickity.data && Flickity.data(container));
    if (!force && container.dataset.sig === sig && (existing || !enable)) return;
    container.dataset.sig = sig;

    destroySlider(container);
    container.innerHTML = '';
    cards.forEach(function (c) { container.appendChild(c); });

    if (enable && cards.length) {
      container.flkty = new Flickity(container, opts);
      fixContain(container.flkty);
    }

    var wrap = container.parentNode;
    if (wrap) {
      wrap.classList.toggle('se-slider--on', !!container.flkty);
      if (container.getAttribute('data-bucket') === 'live') wrap.setAttribute('data-live', '');
    }
    bindProgress(container);
  }

  // Updates countdown text in place, so the live slider isn't rebuilt every minute.
  function refreshText(container, cards) {
    cards.forEach(function (card) {
      var cell = container.querySelector('[data-key="' + card.getAttribute('data-key') + '"]');
      if (!cell || cell === card) return;
      ['[data-status]', '[data-timer]'].forEach(function (sel) {
        var from = card.querySelector(sel), to = cell.querySelector(sel);
        if (from && to) to.textContent = from.textContent;
      });
    });
  }

  // Makes all live cards as tall as the tallest one (only when it's a slider).
  function equalizeLive(container) {
    if (!container) return;
    var cards = container.querySelectorAll('.se-card');
    forEach(cards, function (el) { el.style.minHeight = ''; });
    if (!container.flkty || !container.flkty.isActive) return;
    var max = 0;
    forEach(cards, function (el) { max = Math.max(max, el.offsetHeight); });
    forEach(cards, function (el) { el.style.minHeight = max + 'px'; });
    container.flkty.resize();
  }

  /* ---------- Banner videos --------------------------------------------- */

  // Videos start with preload="none" and a data-src. When a banner comes within
  // 300px of the screen, only the video for the current screen size loads and
  // plays. Crossing 768px pauses the hidden one and plays the visible one.
  function setupBannerVideos(root) {
    forEach(root.querySelectorAll('.se-banner--video'), function (banner) {
      if (banner._seActivate) {
        if (banner.dataset.seVisible) banner._seActivate();
        return;
      }

      banner._seActivate = function () {
        var mobile = MOBILE_MQ.matches;
        var v = banner.querySelector(mobile ? '.se-banner__video--mobile' : '.se-banner__video--desktop');
        var other = banner.querySelector(mobile ? '.se-banner__video--desktop' : '.se-banner__video--mobile');
        if (other && !other.paused) other.pause();
        if (!v || !v.dataset.src) return;
        if (!v.dataset.loaded) {
          v.dataset.loaded = '1';
          v.muted = true;               // required for autoplay in Safari/Chrome
          v.preload = 'auto';
          v.src = v.dataset.src;
        }
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };

      if (!('IntersectionObserver' in window)) {
        banner.dataset.seVisible = '1';
        banner._seActivate();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        banner.dataset.seVisible = '1';
        banner._seActivate();
        io.disconnect();
      }, { rootMargin: '300px' });
      io.observe(banner);
    });
  }

  /* ---------- Section ---------------------------------------------------- */

  function render(root, force) {
    var pool = root.querySelector('[data-offers-pool]');
    if (!pool) return;

    var buckets = {
      live: root.querySelector('[data-bucket="live"]'),
      coming: root.querySelector('[data-bucket="coming"]'),
      missed: root.querySelector('[data-bucket="missed"]')
    };
    var blocks = {
      live: root.querySelector('[data-block="live"]'),
      coming: root.querySelector('[data-block="coming"]'),
      missed: root.querySelector('[data-block="missed"]')
    };
    var emptyMsg = root.querySelector('[data-empty]');
    var now = Math.floor(Date.now() / 1000);
    var groups = { live: [], coming: [], missed: [] };

    forEach(pool.content.querySelectorAll('[data-offer]'), function (node) {
      var starts = toEpoch(node, 'starts');
      var ends = toEpoch(node, 'ends');
      var card = node.cloneNode(true);
      var status = card.querySelector('[data-status]');
      var timer = card.querySelector('[data-timer]');
      var where;

      if (isNaN(starts) || isNaN(ends)) {
        where = 'live';
      } else if (now < starts) {
        where = 'coming';
       if (status) {
  var label = node.getAttribute('data-starts-label');
  status.textContent = label ? 'Coming ' + label : 'Coming ' + fmtShortDate(starts);
}
      } else if (now >= ends) {
        where = 'missed';
        if (status) status.textContent = 'Ended ' + fmtDate(ends);
            } else {
        where = 'live';
        // the discount badge takes the top-left spot when present
        if (status && !card.querySelector('.se-badge--discount')) status.textContent = 'Live Now';
        if (timer) {
          if (card.getAttribute('data-show-timer') === 'true') {
            var threshold = parseInt(root.getAttribute('data-hours-threshold'), 10) || 5;
            timer.textContent = seFormatTimeLeft((ends - now) * 1000, threshold);
          } else {
            timer.textContent = '';
          }
        }
      }

      pickImage(card, where);
      groups[where].push(card);
    });

    // Live: most recently started first (offers without dates go last)
    groups.live.sort(function (a, b) {
      var sa = toEpoch(a, 'starts'), sb = toEpoch(b, 'starts');
      return (isNaN(sb) ? 0 : sb) - (isNaN(sa) ? 0 : sa);
    });

    blocks.live.hidden = groups.live.length === 0;
    blocks.coming.hidden = groups.coming.length === 0;
    blocks.missed.hidden = groups.missed.length === 0;
    emptyMsg.hidden = groups.live.length + groups.coming.length + groups.missed.length > 0;

    whenFlickity(function () {
      var n = groups.live.length;
      syncSlider(buckets.live, groups.live, force, sliderOpts(n), liveShouldSlide(n));
      refreshText(buckets.live, groups.live);
      equalizeLive(buckets.live);

      ['coming', 'missed'].forEach(function (key) {
        var c = groups[key].length;
        syncSlider(buckets[key], groups[key], force, sliderOpts(c), carouselShouldSlide(c));
      });
    });
  }

  function initSection(root, force) {
    if (!root) return;
    setupBannerVideos(root);
    clearInterval(root._seTimer);
    render(root, force);
    root._seTimer = setInterval(function () { render(root, false); }, REFRESH_MS);
  }

  function destroySection(root) {
    if (!root) return;
    clearInterval(root._seTimer);
    forEach(root.querySelectorAll('.se-grid'), destroySlider);
  }

  function eachSection(fn) {
    forEach(document.querySelectorAll('[data-scent-event]'), fn);
  }

  /* ---------- Start + global listeners ---------------------------------- */

  function start() { eachSection(function (root) { initSection(root, true); }); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Different slider options per breakpoint, so rebuild when crossing one
  function onBreakpoint() { eachSection(function (root) { initSection(root, true); }); }
  [MOBILE_MQ, TABLET_MQ].forEach(function (mq) {
    if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
    else if (mq.addListener) mq.addListener(onBreakpoint);
  });

  // Keep live card heights equal on resize and after fonts/images load
  function equalizeAll() {
    eachSection(function (root) { equalizeLive(root.querySelector('[data-bucket="live"]')); });
  }
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeAll, 150);
  });
  window.addEventListener('load', equalizeAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(equalizeAll);

  // Theme editor: rebuild a section after edits, clean up when it is removed
  document.addEventListener('shopify:section:load', function (e) {
    initSection(e.target.querySelector('[data-scent-event]'), true);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    destroySection(e.target.querySelector('[data-scent-event]'));
  });
})();
